export default __webpack_public_path__ + "static/catherine-e0d1cfd4050c48fb22c32c6ebca3d106.png";